import { TableRow } from '@mui/material';
import styled from '@emotion/styled';

export const StyledTableRow = styled(TableRow)({});

export default StyledTableRow;
